export default __webpack_public_path__ + "images/e516d4e50267d4f08dddb600a4bbf6ed.svg";